import React, { Component, Fragment } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment-timezone'
import MomentUtils from '@date-io/moment'

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import { MuiPickersUtilsProvider, TimePicker } from 'material-ui-pickers'
import { DatePicker } from 'material-ui-pickers'
import CircularProgress from '@material-ui/core/CircularProgress';
import { ImageUploader } from './ImageUploader';
import { DocumentUploader } from './DocumentUploader';
import { RichtextEditor } from './RichtextComponent/RichtextEditor';
import { AppTheme } from '../../styles/AppTheme';

export class DynamicForm extends Component {
  constructor(props) {
    super(props);
    this.submitOnlyChanges = false
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.doAction = this.doAction.bind(this);

    this.state = {
      success: true,
      message: '',
      inProcess: false,
    };
    this.locations = {}
    this.setFormState();
  }

  setFormState() {
    this.fields = this.props.formDefinition.steps[0].fields;
    for (let i = 0; i < this.fields.length; i++) {
      const current = this.fields[i];
      if (current.type === 'radio') {
        current.multiSelect = false
        if (current.value && Array.isArray(current.value) && current.value.length > 0) {
          // incase the cloud stores a radio as singleton array
          current.value = current.value[0]
        }
      } else if (current.type === 'check_box') {
        current.multiSelect = true
      }
      if (!current.value) {
        if (current.multiSelect) {
          current.value = [];
        } else {
          current.value = '';
        }
      }
      if (!this.state[current.key]) {
        this.state[current.key] = current.value;
        if (current.valueDisplayScale && this.state[current.key]) {
          this.state[current.key] /= current.valueDisplayScale
        }
      }
      this.fields[i].valid = true;
      if (current.imageUpload || current.documentUpload) {
        current.disabled = true
      }
    }
    this.previousState = this.state;
    console.log('setFormState:', this.state);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const id = target.id;
    this.fields.find(o => o.key === id).valid = true;
    this.setState({
      [id]: value
    });
  }

  handleRichtextInputChange = (value, id) => {
    this.setState({
      [id]: value
    });
  }

  handleSelectChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.fields.find(o => o.key === name).valid = true;
    this.setState({
      [name]: value
    });
  }

  handleUploadSuccess(fieldKey, signedUploadInfo) {
    const field = this.fields.find(o => o.key === fieldKey);
    if (field) {
      field.valid = true
      field.link = signedUploadInfo.link
      this.setState({
        [fieldKey]: signedUploadInfo.fields.key
      })
    }
  }

  doAction() {
    console.log('doAction');

    this.setState({
      inProcess: true, // Nothing should change while sumitting
      message: ''
    });

    if (!this.processValuesBeforeAction()) {
      return;
    }
    this.submit()
  }

  processValuesBeforeAction() {
    let hasChange = false;
    let valid = true;
    delete this.props.apiData.REMOVE_ATTRS
    const REMOVE_ATTRS = []
    for (const current of this.fields) {
      current.valid = true;
      if (current.v_required.value) {
        if (current.condition &&
          this.state[current.condition.key] !== current.condition.value) {
          // If condition doesnt match we can ignore this field.
          current.valid = true;
          // continue;
        } else if (current.multiSelect) {
          if (!this.state[current.key].length) {
            valid = false;
            current.valid = false;
          }
        } else {
          if (this.state[current.key] === '') {
            valid = false;
            current.valid = false;
          }
        }
      }

      this.props.apiData[current.key] = this.state[current.key];
      if (current.valueDisplayScale && this.props.apiData[current.key]) {
        this.props.apiData[current.key] *= current.valueDisplayScale
      }
      if (this.submitOnlyChanges) {
        if (this.state[current.key] !== this.previousState[current.key]) {
          hasChange = true;
        } else {
          delete this.props.apiData[current.key]
        }
      }
      const value = this.state[current.key];
      if (!current.v_required.value) {
        if (value !== this.previousState[current.key]) {
          if(value === '' || value === null || value === undefined) {
            REMOVE_ATTRS.push(current.key)
            delete this.props.apiData[current.key]
          }
        }
      }
    }
    if(REMOVE_ATTRS.length) {
      this.props.apiData.REMOVE_ATTRS = REMOVE_ATTRS
    }

    if (!valid) {
      this.setState({
        success: false,
        inProcess: false,
      });
      return false;
    }

    if (this.submitOnlyChanges && !hasChange && this.props.formDefinition.formType === 'edit') {
      this.setState({
        success: false,
        message: 'No changes',
        inProcess: false
      });
      return false;
    }

    return true;
  }

  submit() {
    if (this.locations) {
      for (const key in this.locations) {
        this.props.apiData[key] = this.locations[key]
      }
    }
    ApiHelper.call(
      { method: this.props.apiMethod, endPoint: this.props.apiEndPoint, jsonBody: this.props.apiData },
      function (err, data) {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err);
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: errorMessage,
            success: false,
            message: errorMessage,
            inProcess: false
          })
          return;
        }
        this.previousState = this.state;
        if (Helper.inArray(['delete', 'del'], this.props.formDefinition.formType)) {
          this.setState({
            success: true,
            message: '',
            inProcess: false
          })
          if (this.props.onClosed) {
            this.props.onClosed();
          }
          if (this.props.onCompleteAction) {
            this.props.onCompleteAction()
          }
        } else {
          this.setState({
            success: true,
            message: Helper.getString('successful'),
            inProcess: false
          })
          if (this.props.onCompleteAction) {
            this.props.onCompleteAction()
          }
        }
      }.bind(this));
  }

  setFormControlParams(current, fromControlParams) {
    if (current.v_required.value) {
      fromControlParams.required = true;
    }
    if (!current.valid) {
      fromControlParams.error = true;
    }
  }

  render() {
    const leftFields = [];
    const rightFields = [];
    this.generateFields(leftFields, rightFields)
    return (
      <form key='form' autoComplete='off' className={css(Styles.form)}>
        {this.generateContent(leftFields, rightFields)}
        {this.generateActions()}
      </form>
    );
  }

  generateFields(leftFields, rightFields) {
    for (const current of this.fields) {
      const formControlParams = {};
      let field;
      let errorTag = '';

      this.setFormControlParams(current, formControlParams);
      if (!current.valid) {
        errorTag = <FormHelperText>{current.v_required.err}</FormHelperText>;
      }
      if (current.condition &&
        this.state[current.condition.key] !== current.condition.value) {
        continue
      }
      switch (current.type) {
      case 'edit_text':
      case 'document':
        field = this.generateEditText(current, formControlParams, errorTag)
        break;
      case 'rich_text':
        field = this.generateRichtext(current, formControlParams, errorTag)
        break;
      case 'radio':
      case 'check_box':
      case 'select':
        field = this.generateSelection(current, formControlParams, errorTag)
        break;
      case 'date':
        field = this.generateDatePicker(current, formControlParams, errorTag)
        break
      default:
        console.error(Helper.getString('unknownFieldType'), current.type)
        continue;
      }
      if (!current.placement) {
        current.placement = 'left' // default
      }
      if (current.placement === 'left') {
        leftFields.push(field);
      } else if (current.placement === 'right') {
        rightFields.push(field);
      }
    }
  }

  handleDateChange = current => date => {
    //console.log(current.key)
    //console.log(date)
    current.valid = true;
    if(!date) {
      return this.setState({
        [current.key]: null
      });
    }
    this.setState({
      [current.key]: date.utc().valueOf()
    });
  }

  generateDatePicker(current, formControlParams, errorTag) {
    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <DatePicker
            keyboard
            // clearable
            keyboardIcon={<i className='material-icons' >calendar_today</i>}
            label={current.label}
            format='DD/MM/YYYY'
            placeholder='DD/MM/YYYY'
            value={this.state[current.key] || null}
            onChange={this.handleDateChange(current)}
            animateYearScrolling={false}
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled = {this.shouldDisable(current)}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  generateContent(leftFields, rightFields) {
    if (rightFields.length > 0) {
      return <div>
        <Grid container>
          <Grid className={css(Styles.leftGridPadding)} item xs={12} sm={6}>
            {leftFields}
          </Grid>
          <Grid className={css(Styles.rightGridPadding)} item xs={12} sm={6}>
            {rightFields}
          </Grid>
        </Grid>
      </div>
    } else {
      return <div>
        <Grid container>
          <Grid item xs={12}>
            {leftFields}
          </Grid>
        </Grid>
      </div>
    }
  }

  generateActions() {
    let buttonText = 'Delete'
    if (Helper.inArray(['add', 'edit'], this.props.formDefinition.formType)) {
      buttonText = 'Save'
    } else if ('approve' === this.props.formDefinition.formType) {
      buttonText = 'Approve'
    }
    const dialogAction = <div className={css(Styles.actions)}>
      <span className={this.state.success ? css(Styles.successMsg) : css(Styles.errorMsg)}>
        {this.state.message}
      </span>

      <Button
        className = {css(Styles.button)}
        variant='contained'
        color='primary'
        disabled={this.state.inProcess}
        onClick={this.doAction}
      >
        {buttonText}
        {this.state.inProcess && <CircularProgress size={24} className={css(Styles.marginLeft)} />}
      </Button>
    </div>

    return dialogAction
  }

  componentDidMount() {
    for (const current of this.fields) {
      if (current.pickLoc) {
        this.initGooglePlaces(current)
      }
    }
  }

  initGooglePlaces(current) {
    const inputNode = document.getElementById(current.key);
    const autoComplete = new window.google.maps.places.Autocomplete(inputNode);
    autoComplete.setFields(['address_component', 'adr_address', 'name', 'formatted_address', 'geometry'])
    autoComplete.addListener('place_changed', () => {
      const place = autoComplete.getPlace();
      this.locations[current.locName] = {
        name: place.name,
        address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
      this.setState({
        [current.key]: place.formatted_address
      })
      // console.log('place:', place);
      //console.log(place.geometry.location.lat());
      //console.log(place.geometry.location.lng());
    });
  }

  generateRichtext(current, formControlParams, errorTag) {
    return (
      <div key={current.key}>
        <p>{current.label}</p>
        <RichtextEditor
          current={current}
          value={this.state[current.key]}
          handleRichtextInputChange={this.handleRichtextInputChange}/>
        {errorTag}
      </div>
    )
  }

  generateEditText(current, formControlParams, errorTag) {
    const fieldParams = {
      id: current.key,
      value: this.state[current.key],
      fullWidth: true
    };
    if (current.multiline) {
      fieldParams.multiline = current.multiline;
      fieldParams.rows = current.rows || 5;
    }
    fieldParams.disabled = this.shouldDisable(current)

    return <div key={current.key}>
      <FormControl fullWidth margin='normal' {...formControlParams}>
        <InputLabel htmlFor={current.label}>{current.label}</InputLabel>
        <Input {...fieldParams} onChange={this.handleInputChange} />
        {errorTag}
      </FormControl>
      {current.imageUpload &&
        <ImageUploader
          uploadId={current.key}
          url={current.link}
          onUploadSuccess={this.handleUploadSuccess.bind(this)}
          width={current.imageWidth}
          height={current.imageHeight}
          uploadType={current.uploadType}
          uploadAccept={current.uploadAccept}
          uploadExt={current.uploadExt}
          borderRadius={0}
        />
      }
      {current.documentUpload && current.link &&
        <a className={css(Styles.openDoc)} href={current.link} target='_blank'>Open file</a>
      }
      {current.documentUpload &&
        <DocumentUploader
          uploadId={current.key}
          uploadType={current.uploadType}
          uploadAccept={current.uploadAccept}
          uploadExt={current.uploadExt}
          onUploadSuccess={this.handleUploadSuccess.bind(this)}
        />
      }
      {this.generatePendingApproval(current)}
    </div>
  }

  generateSelection(current, formControlParams, errorTag) {
    const options = [];
    for (const option of current.options) {
      let cbOption = '';
      if (current.multiSelect) {
        cbOption = <Checkbox color='primary' checked={this.state[current.key].indexOf(option.key) > -1} />
      }
      options.push(
        <MenuItem key={option.key} value={option.key}>
          {cbOption}
          {option.text || option.label}
        </MenuItem>
      );
    }
    let renderParams = {};
    if (current.multiSelect) {
      const searchOptions = current.options;
      renderParams = {
        renderValue: selected => (
          <div className={css(Styles.chips)}>
            {selected.map(value => { return this.findValueInList(value, searchOptions) })}
          </div>
        )
      }
    }
    return <FormControl key={current.key} margin='normal' fullWidth {...formControlParams}>
      <InputLabel htmlFor={current.label}>{current.label}</InputLabel>
      <Select
        multiple={current.multiSelect}
        value={this.state[current.key] ? this.state[current.key] : current.value}
        onChange={this.handleSelectChange}
        {...renderParams}
        input={<Input name={current.key} id={current.key} disabled={this.shouldDisable()} />}
      >
        {options}
      </Select>
      {errorTag}
      {this.generatePendingApproval(current)}
    </FormControl>
  }

  findValueInList(value, searchOptions) {
    const found = searchOptions.find(o => o.key === value)
    if (found) {
      return (<Chip key={value} label={found.text || found.label} />)
    }
  }

  generatePendingApproval(current) {
    return current.pendingApproval ? <p className={css(Styles.pendingApprovalLabel)}>{Helper.getString('pendingAppr')}</p> : ''
  }

  shouldDisable(current) {
    if (current && current.disabled) {
      return true
    }
    return Helper.inArray(['delete', 'del', 'approve'], this.props.formDefinition.formType) ||
      this.state.inProcess
  }
}

const Styles = StyleSheet.create({
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    }
  },
  leftGridPadding: {
    paddingRight: 10
  },
  rightGridPadding: {
    paddingLeft: 10
  },
  errorMsg: {
    paddingRight: 20,
    color: 'red'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  marginLeft: {
    marginLeft: 10
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 20
  },
  pendingApprovalLabel: {
    marginTop: 0,
    marginBottom: 0,
    color: 'orange',
    fontSize: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: 'black',
    fontSize: 10,
    cursor: 'pointer',
  },
  uploadFieldLabel: {
    marginTop: 10,
  },
  button: {
    boxShadow: 'none',
  }
})



// WEBPACK FOOTER //
// ./src/common/components/DynamicForm.js